import {
  buildCategorySeo,
  buildCmsPageSeo,
  buildDefaultSeo as buildDefaultSeoFromBuilder,
  buildErrorSeo,
  buildFallbackSeo,
  buildHomeSeo,
  buildProductSeo,
} from './seo/builders'
import { DEFAULT_SITE_NAME } from './seo/constants'
import type { BuildShopSeoInput, ShopSeoData } from './seo/types'

export type { BuildShopSeoInput, ShopSeoData } from './seo/types'

export const buildDefaultSeo = (siteName = DEFAULT_SITE_NAME): ShopSeoData =>
  buildDefaultSeoFromBuilder(siteName)

export const buildShopSeo = ({
  route,
  pageData,
  productData,
  categoryRouteData,
  homePageData,
  currentPathname,
  siteName = DEFAULT_SITE_NAME,
  activeLocale,
}: BuildShopSeoInput): ShopSeoData => {
  if (route.mode === 'error') {
    return buildErrorSeo({ code: route.code, currentPathname, siteName })
  }

  const homeData = route.mode === 'home' ? homePageData : null
  if (homeData) {
    return buildHomeSeo({ pageData: homeData, siteName, activeLocale })
  }

  if (productData) {
    return buildProductSeo({ route, productData, currentPathname, siteName })
  }

  if (categoryRouteData) {
    return buildCategorySeo({ categoryRouteData, siteName })
  }

  if (pageData) {
    return buildCmsPageSeo({ route, pageData, currentPathname, siteName, activeLocale })
  }

  if (route.mode === 'home') {
    return buildDefaultSeo(siteName)
  }

  return buildFallbackSeo({ route, currentPathname, siteName, activeLocale })
}

export const toAbsoluteUrl = (siteUrl: string, path: string) => {
  if (/^https?:\/\//i.test(path)) return path
  if (path.startsWith('//')) return `https:${path}`
  const cleanBase = siteUrl.replace(/\/+$/, '')
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  return `${cleanBase}${cleanPath}`
}
